import React from "react";
import { Modal, Table, Divider, Typography } from "antd";
import Button from "../../../shared/globalStyling/Button";
import { filterAdGroupsByMediaCompatibility } from "../utils/mediaUtils";

const AdUnitAssignmentModal = ({
  visible,
  onCancel,
  selectedAdUnits,
  availableAdGroups,
  selectedAdGroupIds,
  setSelectedAdGroupIds,
  onAssign,
  assigning,
  mediaType = "IMAGE", // New prop to determine media type filtering
}) => {
  const adUnitColumns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Aspect",
      dataIndex: "aspect",
      key: "aspect",
      render: (text, record) => `${record.width}x${record.height}`,
    },
    {
      title: "File Type",
      dataIndex: "fileType",
      key: "fileType",
    },
    {
      title: "Uploaded At",
      dataIndex: "createdAt",
      key: "createdAt",
      render: text => new Date(text).toLocaleDateString(),
    },
  ];

  // Filter ad groups based on media type compatibility
  const getFilteredAdGroups = () => {
    return filterAdGroupsByMediaCompatibility(availableAdGroups, mediaType);
  };

  const filteredAdGroups = getFilteredAdGroups();

  const adGroupColumns = [
    {
      title: `${mediaType === "VIDEO" ? "Video" : "Ad Unit"} Ad Group Name`,
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Ad Units",
      dataIndex: "adUnits",
      key: "adUnits",
      render: (_, record) => record.medias.length,
    },
    {
      title: "Last Updated",
      dataIndex: "updatedAt",
      key: "updatedAt",
      render: text => new Date(text).toLocaleDateString(),
    },
  ];

  return (
    <Modal
      title={`Assigning ${selectedAdUnits.length} Creative(s) `}
      visible={visible}
      onCancel={onCancel}
      footer={[
        <Button key="cancel" onClick={onCancel}>
          Cancel
        </Button>,
        <Button
          key="assign"
          type="primary"
          loading={assigning}
          onClick={onAssign}
        >
          Assign
        </Button>,
      ]}
      width={1000}
    >
      <Typography.Title level={5}>Selected Creative/s</Typography.Title>
      <Table
        columns={adUnitColumns}
        dataSource={selectedAdUnits}
        pagination={false}
        style={{ marginBottom: 20 }}
      />
      <Divider />
      <Typography.Title level={5}>Available Ad Groups</Typography.Title>
      <Table
        columns={adGroupColumns}
        dataSource={filteredAdGroups}
        rowKey="id"
        rowSelection={{
          type: "checkbox",
          selectedRowKeys: selectedAdGroupIds,
          onChange: selectedRowKeys => setSelectedAdGroupIds(selectedRowKeys),
        }}
      />
    </Modal>
  );
};

export default AdUnitAssignmentModal;
